<template>
  <div class="menuBody" >
      <pollingTree @pollingTree="getMsgFormSon" />
        <!-- <DailyChargeDialog :param="diaLogData" ref="DailyChargeDialog"/> -->
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                押金收费列表 <!--  收费报表管理--押金收费  -->
            <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain  style="background: #38A38A;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:cr:depositCr:depositList'" @click="Create()">生成报表</el-button>
            </div>
            </div>
            <div style="width:130px;float:left;">
                    <el-date-picker
                    v-model="DateTime"
                    size="small"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="TimeSw(DateTime)">
                    </el-date-picker>
            </div>
            <div style="width:200px;float:left;margin-left:230px">
                  <el-select  clearable  v-model="ReceiptWayval" multiple
                    size="small"
                    collapse-tags
                    @change="receiptChange"
                    style="margin-left: 20px;"
                    placeholder="请选择收款方式">
                    <el-option
                    v-for="item in receiptType"
                    :key="item.receiptTypevalue"
                    :label="item.receiptTypelabel"
                    :value="item.receiptTypevalue"
                    >
                    </el-option>
                </el-select>
            </div>
             <div style="width:200px;float:left;margin-left:30px">
                  <el-select  clearable  v-model="ChargeItemVal"
                    size="small"
                    collapse-tags
                    @change="ChargeItemS"
                    style="margin-left: 20px;"
                    placeholder="请选择收款项目">
                    <el-option
                    v-for="item in ChargeItemList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
              <div style="width:200px;float:left;margin-left:30px">
                  <el-select  clearable  v-model="RetreatTypeVal" 
                    size="small"
                    collapse-tags
                    @change="RetreatTypeChange"
                    style="margin-left: 20px;"
                    placeholder="请选择押金状态">
                    <el-option
                    v-for="item in RetreatType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <!-- 票据簿编号	票据号码	收费项目	付款人	房间名称	地址	金额	科目代号	收费方式	收款日期	收款人	备注	原票据簿编号	原票据号码 -->
    <el-table   border  tooltip-effect="light"  show-summary
    :summary-method="getSummaries"  :data="tableData"   v-loading="loading"
    style="overflow-y: scroll;float:right;margin-top:30px" row-key="id"  
    :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column label="序号" type="index" width="60"></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceDm" label="票据簿编号"></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceHm"  label="票据号码"></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceObject" label="收费项目"></el-table-column>
    <el-table-column show-overflow-tooltip prop="crmName" label="付款人"></el-table-column>
     <el-table-column show-overflow-tooltip prop="roomName" label="房间名称"></el-table-column>
    <el-table-column show-overflow-tooltip prop="address" label="地址"></el-table-column>
    <el-table-column show-overflow-tooltip prop="money" label="金额"></el-table-column>
    <el-table-column show-overflow-tooltip prop="subjectCode" label="科目代号"></el-table-column>
    <el-table-column show-overflow-tooltip prop="payMethod" label="收费方式"></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjSkrq" label="收款日期"></el-table-column>
    <el-table-column show-overflow-tooltip prop="payee" label="收款人"></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注"></el-table-column>
  </el-table>
      <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination> -->
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
// import DailyChargeDialog from "../common/DailyChargeDialog";
import pollingTree from "../pollingCommon/pollingTree.vue";

export default {
  name: "DepositRepor",
  components: {pollingTree},
  data() {
    return {
 
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        diaLogVisible: false,
        AllData:[],
        mangroupId:"",
        mangrouplab:"",

        DateTime:"",
        receiptType:[],
        ReceiptWayval:"",

        options:[],
        props: { multiple: true },

        tableData:[],
        ThisTime:"",
        feeCodes:[],
        payMethods:[],


        ChargeItemVal:"",
        ChargeItemList:[],
        RetreatType:[
          {
            "value":"0",
            "label":"未退款",
          },
          {
            "value":"1",
            "label":"已退款",
          },
          {
            "value":"2",
            "label":"退款账单",
          }
        ],
        // 0：未退款 1：已退款 2：退款账单
        RetreatTypeVal:"",
        ThisTimeS:"",
    }
  },
  methods: {
     getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // console.log(columns, data, "columns,data");
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
        }
        // index >= 3 || index <= 11 是你需要计算的列
        // 当然也可以指定一个或者多个列
        // index === 2 || index === 3 这样值求和第二个与第三个列
        else if (index === 7) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              }
            }, 0);
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    TimeSw(dataT){
      	let date = dataT[0];
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let time = year+"-"+month+"-"+dates
        this.ThisTime = time
        let datea = dataT[1];
	    	let yeara = datea.getFullYear();
	    	let montha = datea.getMonth() + 1 < 10 ? '0' + (datea.getMonth() + 1 ): datea.getMonth() + 1
	    	let datesa = datea.getDate()< 10 ? '0' +datea.getDate() : datea.getDate()
        let timea = yeara+"-"+montha+"-"+datesa
        this.ThisTimeS = timea
    },
    RetreatTypeChange(){

    },
    ChargeItemS(){
      let arr =[]
      arr.push(this.ChargeItemVal)
      this.feeCodes = arr
    },
            handleSizeChange(val) {
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    receiptChange(){
      let arr = []
      for(let val of this.receiptType){
        for(let res of this.ReceiptWayval){
           if(val.receiptTypevalue == res){
             arr.push(val.receiptTypelabel)
           }
        }
      }
      this.payMethods = arr
    },
    Derive(){
        // 导出
    },
    Create(){
        // 生成
        this.loading = true
        // console.log("生成报表")
        this.ShareList()
    },
    Print(val){
        // this.$http.post(this.$requestUrl.POST_PRINTRECEIPT,obj).then((res)=>{
           
        // })
    },
    Examine(val){
    },
    getMsgFormSon(data){
      if(data.orgId != null){
        this.loading = true
        this.AllData = data
        this.ShareList()
      }
    },
    ShareList(){
      let obj = {
        "payMethods":this.payMethods, // 方式
        "projectIds":this.AllData.id,
        "feeCodes":this.feeCodes, // 项目
        "startSkRq":this.ThisTime,
        "endSkRq":this.ThisTimeS,
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "isDeposit":this.RetreatTypeVal
}
      this.$http.post(this.$requestUrl.POST_REPOSTDEPOLIST,obj).then((res)=>{
        if(res.data.code == 200){
            let data = res.data.data
            // console.log(data)
            if(data == null){
  this.$message({
                        type: "warning",
                        message: "暂无数据"
                    })
                    this.loading = false
            }else{
                 this.total = res.data.data.total
        this.tableData = data
        this.loading = false
        for(let val of data){
          val.moneytax = val.money - val.tax
        }
            }
        }else{
          this.loading = false
        }
      }).catch(() => {
           this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
       
    },
         RECEIPT(){
        this.$http.get("/charge/web/chargeMethod/selectList").then((res) => {
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "receiptTypevalue":val.id,
              "receiptTypelabel":val.methodName,
            }
            arr.push(obj)
          }
          this.receiptType = arr
        })
      },
    ChargeItem(){
        this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
            let arr = []
            for(let val of res.data.data){
                if(val.feeCategory == "08"){
                    let obj = {
                        "value":val.feeCode,
                        "label":val.feeName,
                    }
                    arr.push(obj)
                }
                this.ChargeItemList = arr
            }
        })
    }
  },
  mounted() {
    this.RECEIPT()
    this.ChargeItem()
    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates
            // console.log(time)
            this.ThisTime = time
            this.ThisTimeS = time
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.el-table_2_column_16 .is-leaf{
  color: #fff;
}
</style>